import React, { ReactNode } from "react";
import ReactDOM from "react-dom";
import "./_iot-model-viewer-modal.scss";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close-cross-icon.svg";

const Backdrop = ({ children }: { children: ReactNode | any }) => {
  const modalBackdropContainer = document.getElementById(
    "modal-container-root"
  );
  const backdrop = <div className="iot-modal-backdrop">{children}</div>;

  return ReactDOM.createPortal(backdrop, modalBackdropContainer as HTMLElement);
};

const IoTModelViewerModal = ({
  children,
  isActive,
  onClose,
}: {
  children: ReactNode;
  isActive: boolean;
  onClose: any;
}) => {
  const ioTModal = (
    <div className="iot-modal">
      <button onClick={onClose} type="button">
        <span className="visually-hidden">Close Modal</span><CloseIcon/>
      </button>
      {children}
    </div>
  );

  return isActive? <Backdrop>{ioTModal}</Backdrop>: null;
};

export default IoTModelViewerModal;
